import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { event_list, event_destroy } from "../../../api/Events";

const typePill = (type) => {
  const t = String(type || "event");
  const bg = t === "test" ? "#f3e8ff" : "#fef2f2";
  const fg = t === "test" ? "#7c3aed" : "#A6192E";
  return (
    <span style={{
      fontSize: 11, fontWeight: 600, color: fg, background: bg,
      padding: "2px 8px", borderRadius: 999, textTransform: "uppercase", letterSpacing: 0.5,
    }}>{t}</span>
  );
};

const audienceLabel = (e) => {
  if (e.course_id) return `Course: ${e.course_name || `#${e.course_id}`}`;
  if (e.grade_id) return `Grade: ${e.grade_name ? `Year ${e.grade_name}` : `#${e.grade_id}`}`;
  return "Whole branch";
};

const AllEvents = () => {
  const branchId = localStorage.getItem("b_id");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const res = await event_list(branchId);
    setRows(res?.data || []);
    setLoading(false);
  };

  useEffect(() => { if (branchId) load(); }, [branchId]);

  const handleDelete = async (id, title) => {
    if (!window.confirm(`Delete "${title}"?`)) return;
    const res = await event_destroy(id, branchId);
    if (res?.status) load();
  };

  return (
    <div className="right-nav" id="dash-event" style={{ padding: "20px 24px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <h4 style={{ fontSize: 18, fontWeight: 600, margin: 0, color: "#1a1a2e" }}>Events &amp; Tests</h4>
        <Link
          to="/branch/events/add"
          style={{
            background: "#A6192E", color: "#fff", padding: "8px 16px",
            borderRadius: 8, textDecoration: "none", fontSize: 13, fontWeight: 600,
          }}
        >
          <i className="fa fa-plus" style={{ fontSize: 11, marginRight: 6 }}></i>
          Add Event / Test
        </Link>
      </div>

      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden" }}>
        <div style={{
          display: "grid",
          gridTemplateColumns: "70px 1fr 110px 160px 160px 140px",
          padding: "10px 14px", background: "#f9fafb",
          fontSize: 11, color: "#6b7280", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5,
        }}>
          <span>Type</span>
          <span>Title</span>
          <span>Date</span>
          <span>Time</span>
          <span>Audience</span>
          <span style={{ textAlign: "right" }}>Action</span>
        </div>
        {loading ? (
          <div style={{ padding: 20, color: "#94a3b8" }}>Loading…</div>
        ) : rows.length === 0 ? (
          <div style={{ padding: 20, color: "#94a3b8" }}>No events yet. Click "Add Event / Test" to create one.</div>
        ) : (
          rows.map((e) => (
            <div key={e.id} style={{
              display: "grid",
              gridTemplateColumns: "70px 1fr 110px 160px 160px 140px",
              padding: "12px 14px", borderTop: "1px solid #f1f5f9", alignItems: "center",
              fontSize: 13, color: "#334155",
            }}>
              <span>{typePill(e.event_type)}</span>
              <span style={{ fontWeight: 500, color: "#1e293b" }}>{e.title}</span>
              <span>{e.date}</span>
              <span>{[e.time_start, e.time_end].filter(Boolean).join(" – ") || "—"}</span>
              <span style={{ fontSize: 12, color: "#64748b" }}>{audienceLabel(e)}</span>
              <span style={{ textAlign: "right", display: "flex", gap: 8, justifyContent: "flex-end" }}>
                <Link
                  to={`/branch/events/edit/${e.id}`}
                  style={{
                    width: 28, height: 28, borderRadius: 6, border: "1px solid #e5e7eb",
                    display: "inline-flex", alignItems: "center", justifyContent: "center",
                    color: "#666", textDecoration: "none", fontSize: 12,
                  }}
                  title="Edit"
                >
                  <i className="fa fa-pencil"></i>
                </Link>
                <button
                  onClick={() => handleDelete(e.id, e.title)}
                  style={{
                    width: 28, height: 28, borderRadius: 6, border: "1px solid #fecaca",
                    background: "#fff", color: "#dc2626", cursor: "pointer", fontSize: 12,
                  }}
                  title="Delete"
                >
                  <i className="fa fa-trash"></i>
                </button>
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AllEvents;
